export enum AnalyticDataType {
  NUM_CYCLES = 'cycles',
  STAGE = 'stage'
}
